import { createSelector } from 'reselect';
import { ContactModel } from '@/typings/models/Contact';

const selectContactsState = (state: DefaultRootState) => state.contacts;
const selectLoadingEffects = (state: DefaultRootState) => state.loading?.effects || {};

export const selectContactList = createSelector(
  [selectContactsState],
  (contacts) => contacts?.list || { items: [] },
);

export const selectContactListQuery = createSelector(
  [selectContactsState],
  (contacts) => contacts?.query || {},
);

export const selectContactListQueryKey = createSelector(
  [selectContactsState],
  (contacts) => contacts?.queryKey || '',
);

export const selectContactListLoading = createSelector(
  [selectLoadingEffects],
  (effects): boolean => Boolean(effects['contacts/fetchList'] || effects['contacts/fetchMore']),
);

export const selectContactDrawer = createSelector(
  [selectContactsState],
  (contacts) => contacts?.drawer || { visible: false },
);

export const selectContactDetailsLoading = createSelector(
  [selectLoadingEffects],
  (effects): boolean => Boolean(effects['contacts/fetchDetails']),
);

export const selectContactById = createSelector(
  [selectContactsState, (_: DefaultRootState, contactId?: string) => contactId],
  (contacts, contactId): ContactModel | undefined =>
    contactId
      ? contacts?.details?.[contactId] || contacts?.list?.items?.find((item) => item.id === contactId)
      : undefined,
);
